import React, { useEffect, useRef } from 'react';
import { db } from './firebaseConfig';
import { doc, onSnapshot } from "firebase/firestore";

const AutoUpdater = () => {
  // Başlangıç versiyonunu null yapıyoruz
  const localVersion = useRef(null);

  useEffect(() => {
    // system koleksiyonundaki metadata dokümanını dinle
    const versionDocRef = doc(db, "system", "metadata");

    // onSnapshot: Veri tabanı her değiştiğinde bu fonksiyon OTOMATİK çalışır
    const unsubscribe = onSnapshot(versionDocRef, (docSnap) => {
      if (docSnap.exists()) {
        const serverVersion = docSnap.data().version;
        
        // 1. Uygulama ilk açıldığında yerel versiyonu ayarla
        if (localVersion.current === null) {
          localVersion.current = serverVersion;
          console.log(`🔌 Bağlantı kuruldu. Mevcut Sürüm: ${serverVersion}`);
        } 
        // 2. Eğer sunucudaki versiyon, elimizdeki versiyondan farklıysa...
        else if (serverVersion !== localVersion.current) {
          console.log(`🚨 HARD FORCE UPDATE! ${localVersion.current} -> ${serverVersion}`);
          
          // Maçta, menüde, nerede olursa olsun ACIMADAN yenile
          // Cache'i temizleyerek (true parametresi) yenile
          window.location.reload(true);
        }
      }
    }, (error) => {
      console.error("Firebase versiyon dinleme hatası:", error);
    });

    // Component kapanırsa dinlemeyi durdur
    return () => unsubscribe();
  }, []);

  return null;
};

export default AutoUpdater;